import { render, staticRenderFns } from "./layout-rows-and-coulmns.vue?vue&type=template&id=6f918b71&scoped=true&"
import script from "./layout-rows-and-coulmns.vue?vue&type=script&lang=js&"
export * from "./layout-rows-and-coulmns.vue?vue&type=script&lang=js&"
import style0 from "./layout-rows-and-coulmns.vue?vue&type=style&index=0&id=6f918b71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f918b71",
  null
  
)

export default component.exports